import ClockIcon from '@atlaskit/icon/core/clock';
import * as React from 'react';

export function SvgClock() {
  return <ClockIcon label="" testId="ads-refreshed-icon" />;
}
